import { AvailableCampaigns } from 'entities/Config'
import {
  getActiveCampaignFromStorage,
  getUserlikeSession,
} from 'utils/sessionStorage'
import { UrlGetParams } from 'consts'
import isRecommendedProduct from 'utils/isRecommendedProduct'
import matchTargeting from 'utils/matchTargeting'
import type { ThemeConfig, ThemesListConfig } from 'entities/Config'

const shouldUseDefaultTheme = () => {
  const urlParams = new URLSearchParams(window?.location?.search || '')
  const tenant = urlParams.get(UrlGetParams.Tenant)

  if (tenant === 'erx') {
    return false
  }

  if (urlParams.has(UrlGetParams.SupportChat) || getUserlikeSession()) {
    return true
  }

  return false
}

const getTheme = (themes: ThemesListConfig): ThemeConfig => {
  const themeConfigEntries = Object.values(themes)
  const defaultTheme: ThemeConfig = themes[AvailableCampaigns.default]

  const urlParams = new URLSearchParams(window?.location?.search || '')

  if (shouldUseDefaultTheme()) {
    return defaultTheme
  }

  if (isRecommendedProduct(urlParams)) {
    const activeCampaign = getActiveCampaignFromStorage()

    const campaignId = activeCampaign.id
    return (
      themeConfigEntries.find(
        (config: ThemeConfig) => config.id === campaignId
      ) || defaultTheme
    )
  }

  return (
    themeConfigEntries.find((config: ThemeConfig) => {
      if (config?.targeting) {
        return matchTargeting(config.targeting)
      }

      return false
    }) || defaultTheme
  )
}

export default getTheme
